import { Variables } from 'react-relay';
import { mockEmptyLoggedInUser } from './mock-data/mockEmptyLoggedInUser';
import { mockFullLoggedInUser } from './mock-data/mockFullLoggedInUser';
import { mockFullLoggedOutUser } from './mock-data/mockFullLoggedOutUser';
import { mockEmptyLoggedOutUser } from './mock-data/mockEmptyLoggedOutUser';
import { mockNonExistentUser } from './mock-data/mockNonExistentUser';
import { mockLoggedOutUserWithSingleCertificate } from './mock-data/mockLoggedOutUserWithSingleCertificate';
import { mockFullLoggedOutUserNoProfileCompany } from './mock-data/mockFullLoggedOutUserNoProfileCompany';
import { mockFullLoggedOutUserNoProfilePosition } from './mock-data/mockFullLoggedOutUserNoProfilePosition';
import { mockFullLoggedOutUserInitialsProfilePicture } from './mock-data/mockFullLoggedOutUserInitialsProfilePicture';
import { mockNoUserLoggedOut } from './mock-data/mockNoUserLoggedOut';
import { mockNoUserLoggedIn } from './mock-data/mockNoUserLoggedIn';
import { mockFullLoggedOutUserManyBadges } from './mock-data/mockFullLoggedOutUserManyBadges';
import { mockFullLoggedOutUserNoRecentCourses } from './mock-data/mockFullLoggedOutUserNoRecentCourses';
import { mockFullLoggedInUserNoRecentCourses } from './mock-data/mockFullLoggedInUserNoRecentCourses';
import { mockFullLoggedOutUserOneBadgeAndCourse } from './mock-data/mockFullLoggedOutUserOneBadgeAndCourse';
import { mockFullLoggedInUserOneBadgeAndCourse } from './mock-data/mockFullLoggedInUserOneBadgeAndCourse';
import { mockFullLoggedOutUserLongBio } from './mock-data/mockFullLoggedOutUserLongBio';
import { mockFullLoggedOutUserNoContactLinks } from './mock-data/mockFullLoggedOutUserNoContactLinks';
import { mockFullLoggedInUserNoBio } from './mock-data/mockFullLoggedInUserNoBio';
import { mockFullLoggedInUserVisitingPrivateProfile } from './mock-data/mockFullLoggedInUserVisitingPrivateProfile';
import { mockFullLoggedInUserNoContactLinks } from './mock-data/mockFullLoggedInUserNoContactLinks';
import { mockFullLoggedOutUserWithoutSomeStats } from './mock-data/mockFullLoggedOutUserWithoutSomeStats';
import { mockFullLoggedInUserWithoutSomeStats } from './mock-data/mockFullLoggedInUserWithoutSomeStats';
import { mockFullLoggedOutUserOneGroup } from './mock-data/mockFullLoggedOutUserOneGroup';
import { mockFullLoggedOutUserTwoGroups } from './mock-data/mockFullLoggedOutUserTwoGroups';
import { mockFullLoggedOutUserWithoutPeerKudos } from './mock-data/mockFullLoggedOutUserWithoutPeerKudos';
import { mockFullLoggedInUserWithoutPeerKudos } from './mock-data/mockFullLoggedInUserWithoutPeerKudos';
import { mockFullLoggedOutUserLongName } from './mock-data/mockFullLoggedOutUserLongName';
import { mockFullLoggedInUserManyBadgesAndCoursesCaseOne } from './mock-data/high-badge-count/mockFullLoggedInUserHighCountBadgesAndCoursesCaseOne';
import { mockFullLoggedInUserManyBadgesAndCoursesCaseTwo } from './mock-data/high-badge-count/mockFullLoggedInUserHighCountBadgesAndCoursesCaseTwo';
import { mockFullLoggedInUserNoBadgesOneCourse } from './mock-data/mockFullLoggedInUserNoBadgesOneCourse';
import { mockLoggedInUserNoConsent } from './mock-data/mockLoggedInUserNoConsent';
import { mockLoggedOutUserNoConsent } from './mock-data/mockLoggedOutUserNoConsent';

export interface MockResponseConfig {
  [operationName: string]: (variables: Variables) => any;
}

const handleBaseUrl = (href: string) => {
  const url = new URL(href);
  const params = new URLSearchParams(url.search);
  const isloggedIn = params.has('baseLoggedIn');

  return isloggedIn ? mockNoUserLoggedIn : mockNoUserLoggedOut;
};

const isBaseUrl = (href: string) => {
  const baseUrlWithPossibleQuery = /\/(\?.*)?$/;

  return baseUrlWithPossibleQuery.test(href);
};

const getMockDataObject = () => {
  if (window.location.href.includes('fullloggedin')) {
    return mockFullLoggedInUser;
  }

  if (window.location.href.includes('emptyloggedin')) {
    return mockEmptyLoggedInUser;
  }

  if (window.location.href.includes('fullloggedout')) {
    return mockFullLoggedOutUser;
  }

  if (window.location.href.includes('privateprofile')) {
    return mockFullLoggedInUserVisitingPrivateProfile;
  }

  if (window.location.href.includes('emptyloggedout')) {
    return mockEmptyLoggedOutUser;
  }

  if (window.location.href.includes('nonexistent')) {
    return mockNonExistentUser;
  }

  if (window.location.href.includes('loggedoutsinglecertificate')) {
    return mockLoggedOutUserWithSingleCertificate;
  }

  if (window.location.href.includes('loggedoutmanybadges')) {
    return mockFullLoggedOutUserManyBadges;
  }

  if (window.location.href.includes('loggedoutnorecentcourses')) {
    return mockFullLoggedOutUserNoRecentCourses;
  }

  if (window.location.href.includes('loggedinnorecentcourses')) {
    return mockFullLoggedInUserNoRecentCourses;
  }

  if (window.location.href.includes('loggedinnobadgesonecourse')) {
    return mockFullLoggedInUserNoBadgesOneCourse;
  }

  if (window.location.href.includes('loggedoutonebadgeandcourse')) {
    return mockFullLoggedOutUserOneBadgeAndCourse;
  }

  if (window.location.href.includes('loggedinonebadgeandcourse')) {
    return mockFullLoggedInUserOneBadgeAndCourse;
  }

  if (
    window.location.href.includes('loggedinusermanybadgesandcoursescaseone')
  ) {
    return mockFullLoggedInUserManyBadgesAndCoursesCaseOne;
  }

  if (
    window.location.href.includes('loggedinusermanybadgesandcoursescasetwo')
  ) {
    return mockFullLoggedInUserManyBadgesAndCoursesCaseTwo;
  }

  if (window.location.href.includes('loggedoutlongbio')) {
    return mockFullLoggedOutUserLongBio;
  }

  if (window.location.href.includes('loggedoutnocontactlinks')) {
    return mockFullLoggedOutUserNoContactLinks;
  }

  if (window.location.href.includes('loggedinnocontactlinks')) {
    return mockFullLoggedInUserNoContactLinks;
  }

  if (window.location.href.includes('loggedinnobio')) {
    return mockFullLoggedInUserNoBio;
  }

  if (window.location.href.includes('loggedoutwithoutsomestats')) {
    return mockFullLoggedOutUserWithoutSomeStats;
  }

  if (window.location.href.includes('loggedinwithoutsomestats')) {
    return mockFullLoggedInUserWithoutSomeStats;
  }

  if (window.location.href.includes('loggedoutnoprofilecompany')) {
    return mockFullLoggedOutUserNoProfileCompany;
  }

  if (window.location.href.includes('loggedoutnoprofileposition')) {
    return mockFullLoggedOutUserNoProfilePosition;
  }

  if (window.location.href.includes('loggedoutuserinitialsprofilepicture')) {
    return mockFullLoggedOutUserInitialsProfilePicture;
  }

  if (window.location.href.includes('loggedoutonegroup')) {
    return mockFullLoggedOutUserOneGroup;
  }

  if (window.location.href.includes('loggedouttwogroups')) {
    return mockFullLoggedOutUserTwoGroups;
  }
  if (window.location.href.includes('loggedoutwithoutpeerkudos')) {
    return mockFullLoggedOutUserWithoutPeerKudos;
  }

  if (window.location.href.includes('loggedinwithoutpeerkudos')) {
    return mockFullLoggedInUserWithoutPeerKudos;
  }

  if (window.location.href.includes('loggedoutlongname')) {
    return mockFullLoggedOutUserLongName;
  }

  if (window.location.href.includes('loggedinnoconsent')) {
    return mockLoggedInUserNoConsent;
  }

  if (window.location.href.includes('loggedoutnoconsent')) {
    return mockLoggedOutUserNoConsent;
  }

  if (isBaseUrl(window.location.href)) {
    return handleBaseUrl(window.location.href);
  }

  return mockFullLoggedInUser;
};

export const getMockResponse = (
  operationName: string,
  variables: Variables,
) => {
  const mockResponses = getMockDataObject();
  if (mockResponses[operationName]) {
    const response = mockResponses[operationName](variables);
    console.log(`Mock response for operation: "${operationName}":`, response);
    return response;
  }
  console.warn(`No mock defined for operation "${operationName}"`);
  return { data: {} }; // Return empty data if no mock is defined for the operation
};
